module.exports = __webpack_public_path__ + "images/12f7bcdaa3053261d76538608b6acd7f.png";